import React, { useState, useEffect, useContext, useCallback } from 'react';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Divider,
  DialogTitle,
  Box,
  Checkbox,
  Typography,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
} from '@mui/material';

import { columbiaAPI } from '@fluke/baseline-client-apis';

import { UserContext } from '../../../../context';

const ShowDialogContent = ({ header, children }) => (
  <DialogContent>
    <DialogContentText sx={{ pb: 1 }}>{header}</DialogContentText>
    <Divider />
    <DialogActions sx={{ justifyContent: 'start' }}>{children}</DialogActions>
  </DialogContent>
);

export function ManageProfile() {
  const { userSettings = {}, updateUserSettings = null } = useContext(UserContext);

  const { temperatureUnits = 'C', showOrganization = false } = userSettings;

  const [open, setOpen] = useState(false);
  const [enableOrganizations, setEnableOrganizations] = useState(false);

  const handleTemperatureUnit = (e) => {
    updateUserSettings({ temperatureUnits: e.target.value });
  };

  useEffect(() => {
    const fetchData = async () => {
      if (open) {
        const data = await columbiaAPI.user.getOrganizations();
        if (data[0]) {
          updateUserSettings({ currentOrganization: data[0].id });
          setEnableOrganizations(true);
        }
      }
    };

    fetchData();
  }, [open]);

  const handleChecked = useCallback(() => {
    // toggle
    const nextValue = !showOrganization;
    updateUserSettings({ showOrganization: nextValue });
  }, [showOrganization]);

  return (
    <Box>
      <Typography onClick={() => setOpen(true)}>Manage Profile</Typography>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
        <DialogTitle>Profile Settings</DialogTitle>
        <ShowDialogContent header="Organization Collaboration">
          <FormControl disabled={!enableOrganizations}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={Boolean(showOrganization)}
                  onChange={(e) => handleChecked(e.target.checked)}
                />
              }
              label="Include All Images from Organization Members"
            />
          </FormControl>
        </ShowDialogContent>
        <ShowDialogContent header="Choose Temperature Unit">
          <FormControl>
            <RadioGroup value={temperatureUnits} onChange={handleTemperatureUnit}>
              <FormControlLabel value="C" control={<Radio />} label="Celsius" />
              <FormControlLabel value="F" control={<Radio />} label="Fahrenheit" />
            </RadioGroup>
          </FormControl>
        </ShowDialogContent>
      </Dialog>
    </Box>
  );
}
